import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import useSeo from "@/hooks/useSeo";
import WhatsAppButton from "@/components/whatsapp/WhatsAppButton";
import { defaultEnquiryMessage } from "@/utilities/whatsapp";

export default function NotFoundPage() {
    useSeo({
        title: "Page Not Found | Container Specialist",
        description: "The page you are looking for does not exist. Return to the Container Specialist homepage.",
        robots: "noindex,follow",
    }, "/404");
    return (
        <section className="cs-container py-24 md:py-32 text-center" data-testid="notfound-page">
            <p className="cs-overline justify-center inline-flex">Error · 404</p>
            <h1 className="mt-4 font-heading uppercase text-5xl md:text-7xl text-cs-navy leading-none">
                Container Not Found
            </h1>
            <p className="mt-4 text-cs-steel max-w-lg mx-auto">
                The page you are looking for isn&apos;t available. It may have been moved or the URL may
                have changed. Try one of the options below.
            </p>
            <div className="mt-8 flex flex-wrap justify-center gap-3">
                <Link to="/" className="cs-btn-outline-dark" data-testid="notfound-home-btn">
                    Back to Home
                    <ArrowRight size={14} strokeWidth={2} />
                </Link>
                <Link to="/containers" className="cs-btn-outline-dark" data-testid="notfound-catalogue-btn">
                    Container Catalogue
                    <ArrowRight size={14} strokeWidth={2} />
                </Link>
                <WhatsAppButton message={defaultEnquiryMessage} label="Message Us" variant="whatsapp" source="notfound" testId="notfound-whatsapp-btn" />
            </div>
        </section>
    );
}
